import React, { useEffect, useState } from 'react';
import RecentUpdatesGroup from '../components/RecentUpdatesGroup';
import FeaturedRelease from '../components/FeaturedRelease';
import productData from '../data/productData.json';
import featuredProductId from '../data/featuredProduct.json';
import { Product, blankProduct } from '../data/interfaces/Product';

const Home: React.FC = () => {
    const [product, setProduct] = useState<Product>(blankProduct);

    const featuredProduct = productData.find((product) => product.id === featuredProductId[0].id);

    useEffect(() => {
        document.title = "SecretAria - Home";
        setProduct(featuredProduct || blankProduct);
    }, []);

    return (
        <div>
            <FeaturedRelease
                product={product}
            />
            <RecentUpdatesGroup />
        </div>
    );
};

export default Home;
